import { Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../common/dimensions/dimension-option-code-raw-dto';

export class APServiceChargeRawDto {
    apBillId: number;
    apPaymentId: number;
    amount: number;
    subCategoryCode: string;
    glAccountLabelCode: string;
    glAccountNumber: string;
    offSetGLAccountNumber: string;
    @Type(() => DimensionOptionCodeRawDto)
    dimensions: DimensionOptionCodeRawDto[];
    description: string;
    payBill: boolean;
}
